import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token:'',
        authCode:[],
        qrCodeSrc: [],
        resourceData:[],
        fontData:[],
        zoomData:[],
        pauseData:[],
        playData:[],
        playJump:[],
        brainstorm:[],
        newBrainstorm:[],
        pageNextData:[],
        pagePrevData:[],
        stormLikeData:[],
        stormCanceLikeData:[],
        toWaiting:[],
    },
    mutations: {
        getQrcode(state,code){
            state.qrCodeSrc = code;
        },
        getresourceData(state,newData){
            state.resourceData = newData;
        }
    },
    actions: {
        
    },
    getters: {

    }
});